<template>
    <customer-view-template>
      <div class="dass-wallet">        
        <TabsWallet />        
      </div>
    </customer-view-template>
</template>

<script>
import CustomerViewTemplate from '../components/templates/CustomerView'
import TabsWallet from '../components/organisms/wallet/TabsWallet.vue'

export default {
  name: 'Wallet',
  components: { 
    CustomerViewTemplate,
    TabsWallet
  }
}
</script>

<style lang="scss" scoped>
.dass-wallet {
  text-transform: uppercase;
  height: 100%;
  width: 100%;  
  padding: 1.5% 3%;
  h1 {
    margin-top: 0;
  }
}

</style>